
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { mixins } from 'vue-class-component';
import VTable from '@/components/shared/table/VTable.vue';
import { Role } from '@/interfaces/models/Role';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './headers';
import { Permission } from '@/enums/Permission';
import Notification from '@/mixins/Notification';

const role = namespace('role');

@Component({
  components: { VTable },
})
export default class RoleTable extends mixins(Notification) {
  @Prop({ type: Array, required: true }) public items!: Role[];
  @role.Action('copy') public copy!: any;
  @role.State('copiedRole') public copiedRole!: Role;

  public headers: ColumnHeader[] = headers;

  public edit(item: Role) {
    this.$router.push({ name: 'role.edit', params: { id: item._id } });
  }

  public editable(item: Role) {
    return !item.isSystem && this.$can(Permission.ROLE_UPDATE);
  }

  public async copyRole(item: Partial<Role>) {
    if (!item) {
      return;
    }

    await this.copy(item);

    if (!this.copiedRole) {
      return this.notifyError('role.notification.roleCopyFailed');
    }

    this.notifySuccess('role.notification.roleCopyStarted');
    this.$router.push({ name: 'role.create' });
  }
}
